import { render } from "./DiameterMeasurementGunReviewModal.vue?vue&type=template&id=bd3021ea&scoped=true"
import script from "./DiameterMeasurementGunReviewModal.vue?vue&type=script&lang=js"
export * from "./DiameterMeasurementGunReviewModal.vue?vue&type=script&lang=js"

import "./DiameterMeasurementGunReviewModal.vue?vue&type=style&index=0&id=bd3021ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd3021ea"]])

export default __exports__